import {
  GET_WALLET_SUCCESS,
  GET_WALLET_REQUEST,
  GET_WALLET_FAILURE,
  DELETE_WALLET_ITEM,
  EMPTY_WALLET_ITEMS,
} from "actions/walletActions";
import { DONE, EMPTY, ERROR, IN_PROGRESS } from "constants/Status";
import { WalletItemsGetResult } from "types/Api/Wallet/walletItemResponse";

const initialWalletState = { status: EMPTY, walletItems: [] };

export const walletReducer = (
  state = initialWalletState,
  action: any
): WalletItemsGetResult => {
  const newState = reduceWalletItemsRequest(state, action);
  return newState;
};

const reduceWalletItemsRequest = (
  state: any,
  action: any
): WalletItemsGetResult => {
  switch (action.type) {
    case GET_WALLET_SUCCESS:
      return {
        ...state,
        status: DONE,
        walletItems: action.response,
      };
    case GET_WALLET_REQUEST:
      return {
        status: IN_PROGRESS,
        walletItems: [],
      };
    case GET_WALLET_FAILURE:
      return {
        status: ERROR,
        walletItems: [],
      };
    case DELETE_WALLET_ITEM:
      return {
        ...state,
        walletItems: state.walletItems.filter(
          (walletItem: { fundingSourceId: any }) =>
            walletItem.fundingSourceId !== action.payload
        ),
      };
    case EMPTY_WALLET_ITEMS:
      return {
        ...state,
        walletItems: [],
      };
    default:
      return state;
  }
};
